`<template>
	<div>						
		<v-row>
			<v-col>	
				<v-text-field hide-details v-model="name" label="Name"></v-text-field>
			</v-col>
		</v-row>
	</div>
</template>

<script>
	export default {
		name: "OrganisationForm", 
		props: {
			organisation: {type: Object}, 
		}, 
		data: () => {
			return {
				name: "", 
			}
		},
		computed: {
			emitOrganisation(){
				return {
					name: this.name, 
				};
			}
		}, 
		watch: {
			emitOrganisation() {
				this.$emit("change", this.emitOrganisation)
			}
		}
	}
</script>